export type HeaderType = 'Landing' | 'Chart';

export const HeaderType: Record<HeaderType, HeaderType> = {
  Landing: 'Landing',
  Chart: 'Chart',
};

export type ShowHeader = boolean | 'desktop' | 'mobile';

export const ShowHeader = {
  Always: true,
  Desktop: 'desktop',
  Mobile: 'mobile',
  Off: false,
};

export interface RouteData {
  showHeader?: ShowHeader;
  headerType?: HeaderType;
  showFooter?: boolean;
  showToTopButton?: boolean;
  urlToNavOnClose?: string[];
}
